<script>
import { mapState } from "vuex";

import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";

export default {
  data() {
    return {
      form: {
        topic: null,
        enquiry: null,
      },
      disableOnSubmit: false,
    };
  },

  props: ["url"],

  mixins: [validateAndSubmit, validationClass],

  computed: {},

  created() {},

  mounted() {},

  watch: {},

  methods: {},

  components: {},
};
</script>
